// extracted by mini-css-extract-plugin
export default {"searchForm":"DataTable_searchForm__5vky8"};